export enum MODULES {
    NOTES = 'notes',
    FILES = 'files',
    CONTACT = 'contact',
    FILE_GENERATOR = 'file_generator'
}

export const getModules = () => Object.values(MODULES);

export enum FILE_GENERATOR_TEMPLATES {
    COOPERATION_CONDITIONS = 'cooperation_conditions',
    TALENT_PROPOSAL = 'talent_proposal'
}

export const getFileGeneratorTemplateDisplayValue = (input: FILE_GENERATOR_TEMPLATES) => {
    switch (input) {
        case FILE_GENERATOR_TEMPLATES.COOPERATION_CONDITIONS:
            return 'Samenwerkingsvoorwaarden';
        case FILE_GENERATOR_TEMPLATES.TALENT_PROPOSAL:
            return 'Talentvoorstel';
        default:
            return 'No File Generator Template found';
    }
}



class ModuleHelper {
    static getModuleDisplayValue(module: any, template?: any) {
        switch (module) {
            case MODULES.NOTES:
                return 'Notities';
            case MODULES.FILES:
                return 'Bestanden';
            case MODULES.CONTACT:
                return 'Contactgegevens';
            case MODULES.FILE_GENERATOR:
                if (template) {
                    switch (template) {
                        case FILE_GENERATOR_TEMPLATES.COOPERATION_CONDITIONS:
                            return 'Samenwerkingsvoorwaarden';
                        case FILE_GENERATOR_TEMPLATES.TALENT_PROPOSAL:
                            return 'Talentvoorstel';
                        default:
                            return 'No File Generator Template found';
                    }
                }

                return 'File generator';
            default:
                return 'No module found';
        }
    }
}

export default ModuleHelper